export const COOKIE_DELIMITER = ';';

export const LAST_VIEWED_GIG_COOKIE = 'last_viewed_gig';
export const LAST_CONTENT_PAGES_COOKIE = 'last_content_pages_';
export const DOMAIN_NAME = 'fiverr.com';

export const DEFAULT_OPTIONS = {
    domain: DOMAIN_NAME,
    path: '/'
};
